<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_ix"></a>Acknowledgments</h2>
<p class="noindent">The editors would like to thank John Cabot University and the American University of Rome for funding the translations in this book.<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?da2f1a3c